import React, { useState, useEffect } from 'react';
import Button from '../../shared/button';
import AuthService from '../../../services/authService';
import Lang from './sections/lang';
import UserSection from './sections/user-section';
import getAssets from '../../../image-loader';
// import appLogo from '../../../assets/brandings/logo.svg';

import { NavLink as Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Navbar, Nav, Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import appLS from '../../../constants/local-storage';
import CompanyDropdown from './sections/company-dropdown';


const authService = new AuthService();
/**
 * function representing header component
 */
function Header({ location, history }) {

  const { t: trans } = useTranslation();


  const [drawerVisibility, setDrawerVisibility] = useState(false);

  const [logo, setLogo] = useState();

  const user = JSON.parse(localStorage.getItem(appLS.user));

  useEffect(() => {
    (async function getFiles() {
      if (!logo) {
        setLogo(await (await getAssets()).logo.default);
      }
    })();
  }, [logo])


  const handleDrawerClick = () => {
    setDrawerVisibility(!drawerVisibility)
    if (!drawerVisibility) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }

  const handleClick = (data) => {
    switch (data) {
      case 'login':
        localStorage.setItem(appLS.redirectUrl, location.pathname);
        authService.login();
        break;
      case 'logout':
        localStorage.removeItem(appLS.companyKey);
        authService.logout();
        break;
      default:
        break;
    }
  }

  const hanldeLogoLick = () => {
    history.push('/');
  }

  // const handleLanguage = () => {
  //   i18n.changeLanguage("no")
  // }

  return (
    <div className="header-wrapper">
      <ul className="top-links">
        <Container>
          <li><a href="https://www.unimicro.no" target="_blank" rel="noopener noreferrer">Uni Micro</a></li>
          <li><a href="https://www.softrig.no" target="_blank" rel="noopener noreferrer">SoftRig</a></li>
          <li><a href="https://info.unieconomy.no" target="_blank" rel="noopener noreferrer">Uni Economy</a></li>
        </Container>
      </ul>
      <Navbar variant="light" expand="lg" className="top-header">
        <Container>
          {/* <Link exact to="/"> */}
          <Navbar.Brand href="#home" className='headerlogo' onClick={hanldeLogoLick}>
            <figure>
              <img src={logo} alt='applogo' />
            </figure>
          </Navbar.Brand>
          {/* </Link> */}
          <div className={`mobile-wrapper ${drawerVisibility ? 'mobileCompatible' : ''}`}>
            <CompanyDropdown />
            <Nav className="mr-auto">
              <Link exact to="/">{trans('header.home')}</Link>
              {/* <Link to="/support">{trans('header.support')}</Link> */}
            </Nav>
            {/* Language switch removed temporarily */}
            {/* <Lang /> */}
            {/* <label>Language (English)</label> */}
            {/* <Button variant="outline-primary" text={trans('header.login')}></Button> */}
            {/* <Language /> */}
            <Form>
              {user ?
                <UserSection
                  userMail={user.profile.email}
                  userName={user.profile.preferred_username}
                  userCompany={user.profile.companyName}
                  handleLogout={handleClick}
                  logoutText={trans('header.log-out')} />
                :
                <Button classes='login-btn' text={trans('header.login')} variant="outline-primary" handleClick={handleClick.bind(null, 'login')} />
              }
            </Form>
          </div>
          <div className={`nav-icon ${drawerVisibility ? 'active' : ''}`} onClick={handleDrawerClick}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Container>
      </Navbar>
      <div className={`backdrop ${drawerVisibility ? 'show' : ''}`}></div>
    </div>
  )
}

export default withRouter(Header);;